import React from "react";

export const PlotArchsHome = () => {
    return(
        <div className='plotArchs-page'>
           <h1>What are Story Archetypes?</h1>
            <p id='archP'>Story archetypes are recurring patterns in the plot and structure of a narrative, found consistently across diverse stories throughout time, cultures, and belief systems. These archetypes utilize a fictional framework to communicate profound truths. Constructing a story based on an archetype establishes a sense of familiarity and connection for the reader.</p>
        </div>
    )
}